module.exports = __webpack_public_path__ + "static/Report-JIRA-183ff676762c112efc4dfbb73a0934f8.png";